import type { ThemeProps as Props } from "models/styles/theme";
import styled from "styled-components/macro";
import { Heading3 } from "styles/elements/Headings";

export const StyledHeading3 = styled(Heading3)<Props>`
  font-weight: 300;
`;
